
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { GdbPathMinimum, PermissionsGroup, DownloadFormat } from '../../store/models.def';
import moment from 'moment';
import accountx from '../../store/modules/accountx';

@Component({
	components: {},
})
export default class AccountFileTile extends Vue {
	@Prop() public readonly data!: GdbPathMinimum;
	@Prop() public readonly group!: PermissionsGroup;
	public get uploadedAt() {
		return moment(this.data.uploadedAt).format('DD/MM/YYYY HH:mm:ss');
	}
	public async download(format: DownloadFormat) {
		await accountx.downloadZip({ group: this.group, format });
	}
}
